import React, {useEffect, useState} from 'react';
import './CampaignInDevelopmentModal.css';
import PageButton from '../../elements/PageButton/PageButton';

const PAGE_ID = 'CampaignInDevelopmentModal';

/**
 * Пояснение к заданию сюжетной кампании: пока кампания не реализована,
 * задание выполнить нельзя, но фракцию-награду можно получить в магазине.
 *
 * Оформление — как у модалки ежедневной награды (свой оверлей с плавным
 * появлением, а не ModalWindow игры).
 */
const CampaignInDevelopmentModal = ({onShop, onClose}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(timeoutId);
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => onClose?.(), 300);
  };

  // Переход в магазин закрывает и саму модалку: задание никуда не денется
  const handleShop = () => {
    onShop?.();
    onClose?.();
  };

  return (
    <div
      className={`campaign-in-development-overlay ${visible ? 'campaign-in-development-overlay_visible' : ''}`}
      onClick={handleClose}
      role={'dialog'}
      aria-modal={'true'}
    >
      <div
        className={`campaign-in-development-modal ${visible ? 'campaign-in-development-modal_visible' : ''}`}
        onClick={(event) => event.stopPropagation()}
      >
        <h2 className={'campaign-in-development-title'}>Сюжетная кампания</h2>

        <p className={'campaign-in-development-text'}>
          Сейчас сюжетная кампания находится в разработке и станет доступна в ближайшее время.
          <br/><br/>А пока ты можешь получить фракцию <span className={'text-crystals'}>Гномы</span> бесплатно
          в магазине — потом за прохождение этой главы кампании ты получишь альтернативную награду.
        </p>

        <div className={'main-menu-buttons campaign-in-development-buttons'}>
          <PageButton
            className={'main-menu-button_shop'}
            onClick={handleShop}
            pageId={PAGE_ID}
            buttonId={'shop'}
          >
            В магазин
          </PageButton>
          <PageButton
            className={'main-menu-button_secondary'}
            onClick={handleClose}
            pageId={PAGE_ID}
            buttonId={'hide'}
          >
            Скрыть
          </PageButton>
        </div>
      </div>
    </div>
  );
};

export default CampaignInDevelopmentModal;
